module.exports = __webpack_public_path__ + "static/media/D2_C2_001.b64a4721.png";